import { useMediaQuery } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { Dispatch, SetStateAction } from 'react'
import { Hits, useInstantSearch } from 'react-instantsearch'
import MapIcon from 'assets/icons/nucleo/18px_map-position.svg'
import { EventCard } from 'components/EventCard'
import { Button, ButtonVariant } from 'components/common/Button'
import { useGetUserEventFavorites } from 'containers/home/useGetUserEventFavorites'
import Empty from 'containers/search/Empty'
import { hitsWrapper } from 'containers/search/style'
import { AutocompleteItem } from 'interfaces/algolia'
import { styled } from 'styles/styled'
import { themeUtils } from 'styles/theme'
import {
  MapDisplayButtonContainer,
  SearchContentContainer
} from './SearchContent.style'

const StyledEmpty = styled(Empty)`
  padding-top: 0;
`

interface SearchContentProps {
  highlightedEventId: number | null
  setSelectedEventId: Dispatch<SetStateAction<number | null>>
  displayMap: boolean
  setDisplayMap: Dispatch<SetStateAction<boolean>>
  expandedMap: boolean
}

export const SearchContent = ({
  highlightedEventId,
  setSelectedEventId,
  displayMap,
  setDisplayMap,
  expandedMap
}: SearchContentProps) => {
  const { data: userEventFavorites } = useGetUserEventFavorites()
  const isMobile = useMediaQuery(themeUtils.maxWidth.md)
  const { results } = useInstantSearch()
  const { t } = useTranslation('common')

  return (
    <SearchContentContainer gap="24px" margin="32px 0">
      {results.hits.length === 0 && <StyledEmpty />}
      {results.hits.length !== 0 && (
        <div css={() => hitsWrapper(expandedMap)}>
          <Hits<AutocompleteItem>
            hitComponent={({ hit }) => {
              return (
                <EventCard
                  hit={hit}
                  priority={hit.__position === 1}
                  isEventSelected={userEventFavorites?.data.some(
                    (favorite) =>
                      favorite.eventId.toString() === hit.objectID.toString()
                  )}
                  highLighted={highlightedEventId === Number(hit.objectID)}
                  setSelectedEventId={setSelectedEventId}
                />
              )
            }}
          />
        </div>
      )}

      {isMobile && !displayMap && (
        <MapDisplayButtonContainer>
          <Button
            label={t('map.show')}
            variant={ButtonVariant.Secondary}
            leftIcon={<MapIcon />}
            onClick={() => setDisplayMap(true)}
          />
        </MapDisplayButtonContainer>
      )}
    </SearchContentContainer>
  )
}
